import { observer } from 'mobx-react';
import React from 'react';
import { Anchor, Grid, GridColumn, Heading, Icon, Readmore, Separator, Text, TGridColumnWidth, useCurrentBreakPoint } from 'telia-front-react';
import { languageSlug } from '../../stores/LanguageStore';
import { NewsParams } from '../../stores/NewsStore';
import { useStores } from '../../stores/RootStore';

interface NewsProps {
  params?: NewsParams;
  title?: string;
  gridClasses?: TGridColumnWidth[];
}

const News = observer((props: NewsProps): React.JSX.Element => {
  const { newsStore, languageStore } = useStores();
  const { params = { offset: 0, perPage: 6 }, title, gridClasses = ['xs-12', 'md-6'] } = props;
  const currentBreakpoint = useCurrentBreakPoint();
  const newsList = newsStore.newsItems(params.perPage);

  React.useEffect(() => {
    newsStore.reloadNews(languageStore.currentLanguage, params);
  }, []);

  const getTitleMaxLength = (): number => {
    if (['xs', 'sm'].includes(currentBreakpoint)) {
      return 1000;
    }
    if (currentBreakpoint === 'md') {
      return 70;
    }
    return 100;
  };

  if (!newsList.length) {
    return null;
  }

  return (
    <Text>
      {title ? (
        <>
          <Heading level={2}>{title}</Heading>
          <Separator spacing="medium" color="invisible" />
        </>
      ) : null}
      <Grid equalHeight element="ul">
        {newsList.map((item) => (
          <GridColumn key={item.id} width={gridClasses}>
            <Grid noWrap={true}>
              <GridColumn width={['min']}>
                <Icon modifiers="#star" size="xs" className="c-brand-secondary-text" />
              </GridColumn>
              <GridColumn width={['max']}>
                <p className="text-small c-neutral-text-subtle">{item.date}</p>
                <Anchor url={`${languageSlug(languageStore.currentLanguage)}/uudised/${item.slug}`} className="text-color-normal">
                  {item.title.length >= getTitleMaxLength() ? <Readmore text={item.title} moreText="" charsToShow={getTitleMaxLength()} /> : item.title}
                </Anchor>
              </GridColumn>
            </Grid>
          </GridColumn>
        ))}
      </Grid>
    </Text>
  );
});

export default News;
